import React from "react";
import { Chat } from "./components/Chat";
import "./App.css";
import { validateUser } from "./components/utils";

const App = () => {
  const handleAuthentication = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("t")
      ? queryParams.get("t")
      : localStorage.getItem("reece_auth_token");
    const userId = queryParams.get("u")
      ? queryParams.get("u")
      : localStorage.getItem("reece_user_id");
    const isEmployee = queryParams.get("e")
      ? queryParams.get("e")
      : localStorage.getItem("reece_employee");
    if (token) {
      const isValid = await validateUser(token);
      if (isValid) {
        localStorage.setItem("reece_auth_token", token);
        localStorage.setItem("reece_user_id", userId);
        localStorage.setItem("reece_employee", isEmployee);
        queryParams.delete("t");
        queryParams.delete("e");
        queryParams.delete("u");
        window.history.replaceState(null, null, window.location.pathname);
      } else {
        window.location.href = "/authentication/signin";
      }
    } else {
      window.location.href = "/authentication/signin";
    }
  };

  return (
    <div className="app">
      <div className="chat-container">
        <div className="header">
          <img className="header-logo" src="/assets/bot.png" alt="reece" />
          <p className="header-title">Reece Chat</p>
        </div>
        <Chat />
      </div>
    </div>
  );
};

export default App;
